import { useNavigate } from "react-router-dom"
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarSeparator,
} from "@/components/ui/sidebar"
import { Button } from "@/components/ui/button"
import { Switch } from "@/components/ui/switch"
import { useTheme } from "@/contexts/ThemeContext"
import { OrgUsersManager } from "@/components/OrgUsersManager"

export function SettingsSidebar() {
  const { theme, setTheme } = useTheme()
  const navigate = useNavigate()

  return (
    <SidebarContent>
      <SidebarGroup>
        <SidebarGroupLabel>Settings</SidebarGroupLabel>
        <Button
          variant="outline"
          size="sm"
          className="mx-2"
          onClick={() => navigate("/change-password")}
        >
          Change Password
        </Button>
      </SidebarGroup>
      <SidebarSeparator />
      <SidebarGroup>
        <SidebarGroupLabel>Team</SidebarGroupLabel>
        <OrgUsersManager />
      </SidebarGroup>
      <SidebarSeparator />
      <SidebarGroup>
        <SidebarGroupLabel>Appearance</SidebarGroupLabel>
        <div className="flex items-center justify-between gap-2 px-2 py-2">
          <label
            htmlFor="dark-mode-switch"
            className="text-sm font-medium text-sidebar-foreground"
          >
            Dark mode
          </label>
          <Switch
            id="dark-mode-switch"
            checked={theme === "dark"}
            onCheckedChange={(checked) => setTheme(checked ? "dark" : "light")}
            aria-label="Toggle dark mode"
          />
        </div>
      </SidebarGroup>
      <SidebarSeparator />
    </SidebarContent>
  )
}
